import { disabledTypes, FormInputTypes } from "./form.component";
import { emailValidator, requiredValidator } from "./validators.form";

import eventManager from "../../helpers/event.manager";
const gender = ["Male", "Female"];
const ORG_TYPE_OPTIONS = [
  { value: "none", label: "None" },
  { value: "Private school", label: "Private School" },
  { value: "Public school", label: "Public School" },
  { value: "Parks & recreation", label: "Parks & Recreation" },
  { value: "Youth Athletic Association", label: "Youth Athletic Association" },
  { value: "YMCA/YWCA", label: "YMCA/YWCA" },
  { value: "private league", label: "Private League" },
  { value: "Boys & Girls Club", label: "Boys & Girls Club" },
  {
    value: "Multi-sport Youth Association",
    label: "Multi-sport Youth Association",
  },
  {
    value: "Church/Religious Organization",
    label: "Church/Religious Organization",
  },
  { value: "Travel or Club Team", label: "Travel or Club Team" },
];
const states = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const parentFormConfig = [
  {
    group: [
      {
        label: "Personal Information",
        labelKey: "account.personalInformation",
        type: FormInputTypes.TITLE,
      },
    ],
  },
  {
    group: [
      {
        name: "first_name",
        label: "First Name",
        labelKey: "account.firstName",
        placeholder: "name",
        placeholderKey: "account.namePlaceholder",
        type: FormInputTypes.TEXT,
        autoComplete: "given-name",
        validator: requiredValidator,
        className: "parent-form-input",
      },
      {
        name: "last_name",
        label: "Last Name",
        labelKey: "account.lastName",
        placeholder: "name",
        placeholderKey: "account.namePlaceholder",
        type: FormInputTypes.TEXT,
        autoComplete: "family-name",
        validator: requiredValidator,
        className: "parent-form-input",
      },
      {
        name: "account_email",
        label: "Email",
        labelKey: "account.email",
        placeholder: "org@email.com",
        type: FormInputTypes.TEXT,
        intype: "email",
        autoComplete: "email",
        validator: emailValidator,
        className: "parent-form-input",
        disabledCondition: {
          type: disabledTypes.dependsOnAnotherFiled,
          field: "username",
        },
      },
    ],
  },
  {
    group: [
      {
        name: "phone",
        label: "Cell Phone",
        labelKey: "account.cellPhone",
        placeholder: "(212) 555-1234",
        type: FormInputTypes.PHONE,
        autoComplete: "tel",
        className: "parent-form-input",

        validator: requiredValidator,
      },
      {
        name: "birth_date",
        label: "Date of Birth",
        labelKey: "account.dateOfBirth",
        type: FormInputTypes.DATE,
        autoComplete: "bday",
        className: "parent-form-input",
      },
      {
        name: "gender",
        label: "Gender",
        labelKey: "account.gender",
        placeholder: "",
        type: FormInputTypes.LOOKUP_SELECT,
        data: gender,
        optionKeys: {
          Male: "account.male",
          Female: "account.female",
        },
        validator: requiredValidator,
        className: "parent-form-input",
      },
    ],
  },

  {
    group: [
      {
        name: "optin_email",
        label: "Opt-in Email",
        labelKey: "account.optInEmail",
        type: FormInputTypes.CHECKBOX,
      },
    ],
  },
  {
    group: [
      {
        label: "Contact Details",
        labelKey: "account.contactDetails",
        type: FormInputTypes.TITLE,
      },
    ],
  },
  {
    group: [
      {
        name: "address_1",
        label: "Address",
        labelKey: "account.address",
        placeholder: "Address",
        placeholderKey: "account.address",
        style: { width: "100%", maxWidth: "600px" },
        type: FormInputTypes.TEXT,
        autoComplete: "address-line1",
        validator: requiredValidator,
        className: "parent-form-input",
      },
    ],
  },
  {
    group: [
      {
        name: "address_2",
        label: "",
        placeholder: "Address",
        placeholderKey: "account.address",
        style: { width: "100%", maxWidth: "600px" },
        type: FormInputTypes.TEXT,
        autoComplete: "address-line2",
        className: "parent-form-input",
      },
    ],
  },

  {
    group: [
      {
        name: "zip_code",
        label: "Zip Code",
        labelKey: "account.zipCode",
        placeholder: "ZipCode",
        placeholderKey: "account.zipCode",
        type: FormInputTypes.TEXT,
        autoComplete: "postal-code",
        maxLength: 8,
        validator: requiredValidator,
        intype: "number",

        className: "parent-form-input-short",
      },
      {
        name: "city",
        label: "City",
        labelKey: "account.city",
        placeholder: "City",
        placeholderKey: "account.city",
        type: FormInputTypes.TEXT,
        autoComplete: "address-level2",
        validator: requiredValidator,

        className: "parent-form-input-short",
      },
      {
        name: "state",
        label: "State",
        labelKey: "account.state",
        placeholder: "",
        type: FormInputTypes.LOOKUP_SELECT,
        autoComplete: "address-level1",
        data: states,
        validator: requiredValidator,
        onChange: (data) => {
          console.log("state change");
          eventManager.send("state.change", data);
        },
        className: "parent-form-input",
      },
      {
        name: "county",
        label: "County",
        labelKey: "account.county",
        placeholder: "",
        type: FormInputTypes.LOOKUP_SELECT,
        lookup: "counties",
        // validator: requiredValidator,
        className: "parent-form-input",
      },
    ],
  },
  {
    group: [
      {
        label: "What sport(s) do you coach?",
        labelKey: "account.sportsQuestion",
        type: FormInputTypes.TITLE,
      },
    ],
  },

  {
    group: [
      {
        name: "organization_name",
        label: "Organization Name",
        labelKey: "account.organizationName",
        placeholder: "",
        type: FormInputTypes.TEXT,
        autoComplete: "organization",
        validator: requiredValidator,
        className: "parent-form-input",
      },
      {
        name: "organization_type",
        label: "Organization Type",
        labelKey: "account.organizationType",
        placeholder: "",
        type: FormInputTypes.LOOKUP_SELECT,
        data: ORG_TYPE_OPTIONS.map((item) => item.value),
        optionKeys: {
          none: "account.organizationTypes.none",
          "Private school": "account.organizationTypes.privateSchool",
          "Public school": "account.organizationTypes.publicSchool",
          "Parks & recreation": "account.organizationTypes.parksRecreation",
          "Youth Athletic Association": "account.organizationTypes.youthAthleticAssociation",
          "YMCA/YWCA": "account.organizationTypes.ymca",
          "private league": "account.organizationTypes.privateLeague",
          "Boys & Girls Club": "account.organizationTypes.boysGirlsClub",
          "Multi-sport Youth Association": "account.organizationTypes.multiSport",
          "Church/Religious Organization": "account.organizationTypes.religious",
          "Travel or Club Team": "account.organizationTypes.travelClub",
        },
        validator: requiredValidator,
        className: "parent-form-input",
      },
    ],
  },

  {
    group: [
      {
        name: "sport",
        label: "Sports",
        labelKey: "account.sports",
        placeholder: "User's sports",
        placeholderKey: "account.sportsPlaceholder",
        type: FormInputTypes.LOOKUP_MULTI_SELECT_REACT,
        lookup: "LK_SPORTS",
        isTextArray: true,
        format: (value) => value && value.map((v) => v.label),
        className:"parent-form-input"
      },
      {
        name: "age_groups",
        label: "Age Group",
        labelKey: "account.ageGroup",
        type: FormInputTypes.LOOKUP_MULTI_SELECT_REACT,
        lookup: "LK_AGE_GROUPS",
        isTextArray: true,
        format: (value) => value && value.map((v) => v.label),
        className:"parent-form-input"
      },
    ],
  },
  // {
  //   name: "phone",
  //   label: "Cell Phone",
  //   placeholder: "(212) 555-1234",
  //   type: FormInputTypes.PHONE,
  //   validator: requiredValidator,
  // },
];

export const PARENT_PLAYERS_HEADERS = [
  {
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    maxWidth: 50,
  },
  {
    field: "last_name",
    headerName: "Last Name",
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "first_name",
    headerName: "First Name",
    sortable: true,
    filter: "agTextColumnFilter",
  },

  {
    field: "house_hold",
    headerName: "House Hold",
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "address",
    headerName: "Address",
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "team.value",
    headerName: "Team",
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "team.season",
    headerName: "Season",
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "organization.value",
    headerName: "Organization",
    sortable: true,
    filter: "agTextColumnFilter",
  },
];
